<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill" *ngIf="payments">
        <dx-data-grid
            #dataGrid
            keyExpr="id"
            [showBorders]="true"
            [dataSource]="payments"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onExporting)="onExporting($event)"
            (onRowPrepared)="rowPrepare($event)"
            (onOptionChanged)="onOptionChanged($event)"
            >
            <dxi-column dataField="id" width="90"></dxi-column>
            <!-- <dxi-column dataField="salesOrderList" caption="SalesOrders" width="125"></dxi-column> -->
            <dxi-column dataField="invoiceListString" caption="Invoices" width="125"></dxi-column>
            <dxi-column dataField="paymentDate" width="125"></dxi-column>
            <dxi-column dataField="dealer.displayName" caption="Dealer" width="300"></dxi-column>
            <!-- <dxi-column dataField="paymentLines[0].orderLineDetails[0].packingSlip.invoiceNumber" caption="Invoice #" width="200"></dxi-column> -->
            <dxi-column dataField="referenceNumber" caption="Reference #" width="200"></dxi-column>
            <dxi-column dataField="paymentAmount" caption="Total" dataType="number" [format]="{ type: 'currency', precision: 2 }" width="150"></dxi-column>
            <dxi-column dataField="paymentMethod.name" caption="Method" width="150"></dxi-column>
            <dxi-column dataField="notes" width="300"></dxi-column>
            <dxi-column dataField="readyToExport" width="125"></dxi-column>
            <dxi-column dataField="exported" editorType="dxCheckBox" width="125"></dxi-column>
            <dxi-column dataField="quickBooksId" caption="QB Id" width="125"></dxi-column>
            <dxi-column dataField="quickBooksLastExport" caption="Exported" width="125"></dxi-column>
            <dxi-column dataField="created" width="125"></dxi-column>
            <dxi-column dataField="createdBy" width="125"></dxi-column>
            <dxi-column></dxi-column>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="payment-search-grid"></dxo-state-storing>
            <dxo-selection [mode]="'multiple'"></dxo-selection>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button
                    type="button"
                    (click)="open(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                    class="btn btn-sm btn-success"
                >
                    Open
                </button>
                <button type="button" (click)="toggleShowAll()" class="btn btn-sm btn-warning ms-2">{{ filter.showAll ? 'Show Recent' : 'Show All' }}</button>
                <button
                    type="button"
                    (click)="markReadyForExport(dataGrid.instance.getSelectedRowsData())"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                    class="btn btn-sm btn-success ms-2"
                >
                    Ready To Export
                </button>
                <button
                    type="button"
                    (click)="payWithoutQuickBooks(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="
                        dataGrid.instance.getSelectedRowsData().length !== 1 ||
                        dataGrid.instance.getSelectedRowsData()[0].quickBooksId ||
                        dataGrid.instance.getSelectedRowsData()[0].quickBooksLastExport
                    "
                    class="btn btn-sm btn-success ms-2"
                >
                    Pay w/o QuickBooks
                </button>
                <button class="btn btn-sm btn-secondary ms-2" (click)="getData()">Refresh Data</button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="payments" class="me-3">
                    <strong>
                        {{ dataGrid.instance.totalCount() + ' items' }}
                        {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                    </strong>
                </span>
            </div>
        </dx-data-grid>
    </div>
</div>
